
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const QuotationSearch = () => {
  const [quotationCode, setQuotationCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSearchQuotation = async () => {
    if (!quotationCode.trim()) {
      toast({
        title: "Erro",
        description: "Por favor, insira um código de orçamento",
        variant: "destructive",
      });
      return;
    }

    setIsLoading(true);
    try {
      const { data, error } = await supabase
        .from("quotations")
        .select(`
          *,
          customer:customers(name)
        `)
        .ilike("code", quotationCode.trim())
        .maybeSingle();

      if (error) throw error;

      if (data) {
        window.open(`/quotation/${data.code}`, '_blank');
      } else {
        toast({
          title: "Não encontrado",
          description: "Nenhum orçamento encontrado com este código",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error("Error fetching quotation:", error);
      toast({
        title: "Erro",
        description: "Erro ao buscar orçamento",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearchQuotation();
    }
  };

  return (
    <div className="relative w-full max-w-md mx-auto">
      <div className="flex items-center gap-2">
        <Input
          placeholder="Digite o código do orçamento"
          value={quotationCode}
          onChange={(e) => setQuotationCode(e.target.value)}
          onKeyPress={handleKeyPress}
          className="w-full bg-white shadow-lg border-2 border-[#0073B7] h-10 text-base font-medium text-[#004080] placeholder:text-gray-400"
        />
        <Button 
          onClick={handleSearchQuotation}
          disabled={isLoading}
          className="bg-[#0073B7] hover:bg-[#004080] text-white"
        >
          {isLoading ? (
            <div className="animate-spin h-5 w-5 border-2 border-t-transparent border-white rounded-full" />
          ) : (
            <Search className="h-5 w-5" />
          )}
        </Button>
      </div>
    </div>
  );
};
